import {
  Component,
  ViewChild,
  ElementRef,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { BackendApiService } from '../services/backend-api.service';
import { BackendSocketService } from '../services/backend-socket.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { ModalDirective, BsModalRef } from 'ngx-bootstrap/modal';
import _ from 'lodash';
import { NgForm } from '@angular/forms';
import * as $ from 'jquery';
import { interval } from 'rxjs';
import { Subscription } from 'rxjs';
import { CommonService } from '../services/common.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-oldbadla',
  templateUrl: './oldbadla.component.html',
  styleUrls: ['./oldbadla.component.scss'],
})
export class OldbadlaComponent implements OnInit {
  @ViewChild('orderModal') orderModal: ModalDirective;
  @ViewChild('badlaInfoModal') badlaInfoModal: ModalDirective;
  @ViewChild('addBadlaOrder') addBadlaOrder: NgForm;

  badlaRecord: any = [];
  badlaRecordDetails: any = [];
  randomString = this.getRandomString(5);
  badlaRoomString = this.getRandomString(6);
  subscription: Subscription;
  subscriptionBadla: Subscription;
  subscriptionGetRate: Subscription;
  subscriptionAry: Subscription[] = [];
  subscriptionDetail;
  subscriptionInstrument;
  marketType;
  badlaInstruments = [];
  allScript = [];
  withoutFilterScript = [];
  totalRoom = [];
  uniqId = this.getRandomString(5);
  accessApproval: any;
  selectedScript = null;
  selectedBadlaType = 'ALL';
  selectedBadlaTypeFrm;
  endOrder: Boolean = false;
  Toast = {
    type: '',
    title: '',
    timeout: 0,
    body: '',
  };
  userId = '1';
  badlaInfo: any;
  diffrenceRate: number | null = null;
  initialDutyValue: any;
  instrumentCategory = [
    { name: 'ALL' },
    { name: 'COPPER' },
    { name: 'CRUDE' },
    { name: 'SILVER' },
    { name: 'GOLD' },
    { name: 'GAS' },
  ];

  badlaInstrument = [];
  mcxBadlaInstrument = [];
  comexBadlaInstrument = [];
  dgcxBadlaInstrument = [];
  allComexInstrument = [];
  allMcxInstrument = [];
  allDgcxInstrument = [];
  badlaOrderList = [];
  permeBadlaOrderList = [];
  orderInstruments = [];
  settledIns = [];
  badlaParams: {
    badla: null;
  };
  isBrokrageCheck = false;
  isBrokrageCheckEnd = false;
  isEndClosingRate = false;
  isComexROCheck = false;
  isMcxROCheck = false;
  isDgcxROCheck = false;
  dollerClCheck = false;
  isBrokrageROCheck = false;
  closingRate;
  settlementType = '1';
  filter = {
    mcxbadlaInst: null,
    mcxType: null,
    mcxQty: null,
    mcxPrice: null,
    mcxBroType: null,
    mcxBroAmount: null,
    dgcxbadlaInst: null,
    dgcxType: null,
    dgcxQty: null,
    dgcxPrice: null,
    dgcxBroType: null,
    dgcxBroAmount: null,
    comexbadlaInst: null,
    comexType: null,
    comexQty: null,
    comexPrice: null,
    comexBroType: null,
    comexBroAmount: null,
    type: null,
    id: null,
    duty: null,
    reference: null,
    endandopen: null,
    openingAmount: '0',
    mcxRolloverbadlaInst: null,
    mcxRolloverType: null,
    mcxRolloverQty: null,
    mcxRolloverPrice: null,
    mcxRolloverBroType: null,
    mcxRolloverBroAmount: null,
    comexRolloverbadlaInst: null,
    comexRolloverType: null,
    comexRolloverQty: null,
    comexRolloverPrice: null,
    comexRolloverBroType: null,
    comexRolloverBroAmount: null,
    dgcxRolloverbadlaInst: null,
    dgcxRolloverType: null,
    dgcxRolloverQty: null,
    dgcxRolloverPrice: null,
    dgcxRolloverBroType: null,
    dgcxRolloverBroAmount: null,
    reverse: null,
    badlaType: null,
  };

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private backendApiService: BackendApiService,
    private commonService: CommonService,
    private backendSocketService: BackendSocketService,
    private spinnerService: NgxSpinnerService,
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      let data = {
        isActive: true,
      };
      this.backendApiService
        .liveBadlaInstruments(data)
        .subscribe((response) => {
          if (response.status == true) {
            this.badlaInstrument = response.data;
          }
        });

      let filterData = {
        userId: 1,
      };
      this.backendApiService
        .badlaInstruments(filterData)
        .subscribe((response) => {
          if (response.status == true) {
            this.badlaRecordDetails = response['data'];
            var grpBadla = _.groupBy(response['data'], 'exchange');
            this.mcxBadlaInstrument = grpBadla['MCX'];
            this.comexBadlaInstrument = grpBadla['COMEX'];
            this.dgcxBadlaInstrument = grpBadla['DGCX'];

            this.allComexInstrument = grpBadla['COMEX'];
            this.allMcxInstrument = grpBadla['MCX'];
            this.allDgcxInstrument = grpBadla['DGCX'];
          }
        });

      this.marketType = 'livebadla';
      let authToken = params.authToken;
      let reqObj = {
        token: authToken,
      };
      this.backendApiService.checkAuthToken(reqObj).subscribe((response) => {
        if (response['status'] == true) {
          this.accessApproval = true;
          localStorage.setItem('accessToken', authToken);
          localStorage.setItem('userId', response['userId']);
          this.getAllScript();
        } else {
          this.accessApproval = false;
        }
      });
      // this.getUserWiseScript();

      this.getRate();
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.subscriptionBadla) {
      this.subscriptionBadla.unsubscribe();
    }
    // console.log('this.subscriptionBadla+++++++',this.subscriptionBadla);
    this.subscriptionAry.forEach((subscription) => subscription.unsubscribe());
    if (this.subscriptionGetRate) {
      this.subscriptionGetRate.unsubscribe();
    }
  }

  getAllScript() {
    let data = {
      isActive: true,
    };
    this.backendApiService
      .liveBadlaInstrumentsMarketWatch(data)
      .subscribe((response) => {
        if (response.status == true) {
          //this.badlaInstruments= response.data;
          const order = ['GOLD', 'SILVER', 'COPPER', 'CRUD'];
          this.allScript = response.data;
          this.allScript.map((dt) => {
            dt.displayOrder = dt.displayOrder ? Number(dt.displayOrder) : 100;
          });

          this.allScript = _.sortBy(this.allScript, 'displayOrder');

          // this.allScript.sort((a, b) => {
          //   const indexA = order.indexOf(a.badlaType);
          //   const indexB = order.indexOf(b.badlaType);
          //   return (indexA === -1 ? order.length : indexA) - (indexB === -1 ? order.length : indexB);
          // });
          // this.allScript = this.allScript.sort((a, b) => order.indexOf(a.badlaType) - order.indexOf(b.badlaType));

          this.withoutFilterScript = response.data;
          this.withoutFilterScript = _.sortBy(
            this.withoutFilterScript,
            'settingName',
          );
          let badlaData = response.data;
          let instrumentAry = [];
          badlaData.forEach((element) => {
            instrumentAry = _.map(element.instrumentToken, function (resIns) {
              return resIns + '_full';
            });
            element.instrumentToken = instrumentAry;
            this.setBadlaInstrument(element);
          });
        }
      });
  }

  getUserWiseScript() {
    let userScriptReq = {
      userId: '1',
    };
    this.backendApiService
      .getUserWiseScript(userScriptReq)
      .subscribe((responseUserWiseScript) => {
        if (responseUserWiseScript['status'] == true) {
          this.badlaInstruments =
            responseUserWiseScript['data'][0]['scriptDetail'];
          setTimeout(() => {
            // console.log('this.allScript++++++++',this.allScript);
            // console.log('this.badlaInstruments++++++++',this.badlaInstruments);
            let filterScriptAry = [];
            this.allScript.forEach(function (item, index, array) {
              var ItemIndex = this.badlaInstruments.find(
                (b) => b._id === item._id,
              );
              if (!ItemIndex) {
                filterScriptAry.push(item);
              }
            }, this);
            this.allScript = filterScriptAry;
          }, 500);
        } else {
          this.badlaInstruments = [];
        }
      });
  }
  setInstrument(instrumentTokens) {
    let tokenIds = instrumentTokens.map((ite, index) => {
      return ite.instrument_token + '_full';
    });
    tokenIds = tokenIds.toString();
    var requested = {
      roomId: this.randomString,
      instrument_token: tokenIds,
      uniqId: this.uniqId,
      marketType: 'market',
      response_type: 'full',
    };
    this.totalRoom.push(requested.roomId);
    var observable = interval(400);
    this.subscription = observable.subscribe((x) => {
      this.backendSocketService.setInstrument(JSON.stringify(requested));
    });
    localStorage.setItem('totalRoom', this.totalRoom.join(', '));
  }
  setBadlaInstrument(element) {
    let tokenIds = element.instrumentToken.toString();
    let uniqId = element._id;
    var requested = {
      roomId: this.getRandomString(5),
      instrument_token: tokenIds,
      marketType: 'badla',
      uniqId: uniqId,
      equation: element.equation,
      response_type: 'full',
      duty: element['settingValue'],
    };
    this.totalRoom.push(requested.roomId);
    var observable = interval(600);
    this.subscriptionBadla = observable.subscribe((x) => {
      this.backendSocketService.setInstrument(JSON.stringify(requested));
    });

    this.subscriptionAry.push(this.subscriptionBadla);
    localStorage.setItem('totalRoom', this.totalRoom.join(', '));
  }

  getRate() {
    this.subscriptionGetRate = this.backendSocketService
      .getInstrument()
      .subscribe((response) => {
        var findDiffrence = this.badlaInstruments.find(
          (b) => b._id === response['uniqId'],
        );
        let diffValue = 0;
        let reverse = '0';
        if (findDiffrence) {
          reverse = findDiffrence['reverse'] ? findDiffrence['reverse'] : '0';
          //diffValue = (findDiffrence['diffrenceValue']) ? findDiffrence['diffrenceValue'] : 0;
        }
        if (response.marketType == 'badla') {
          if (response.data.length > 2) {
            response.data[0]['buy_price_0'] =
              response.data[0]['buy_price_0'] + diffValue;
            response.data[0]['sell_price_0'] =
              response.data[0]['sell_price_0'] + diffValue;
            response.data[0]['last_price'] =
              response.data[0]['last_price'] + diffValue;

            //mcx previous buy
            $(
              '#' +
                response.data[0].instrument_token +
                '_' +
                response.uniqId +
                '_mcx_high',
            ).html(response.data[0]['ohlc_high']);
            $(
              '#' +
                response.data[0].instrument_token +
                '_' +
                response.uniqId +
                '_mcx_low',
            ).html(response.data[0]['ohlc_low']);

            let preAmntBuyMcx = $(
              '#' +
                response.data[0].instrument_token +
                '_' +
                response.uniqId +
                '_prev_buy_comex',
            ).val();
            if (
              Number(response.data[0]['buy_price_0']) >= Number(preAmntBuyMcx)
            ) {
              $(
                '#' +
                  response.data[0].instrument_token +
                  '_' +
                  response.uniqId +
                  '_badla_buyP_bg',
              )
                .removeClass('debit-color-bg')
                .addClass('credit-color-bg');
            }
            if (
              Number(response.data[0]['buy_price_0']) < Number(preAmntBuyMcx)
            ) {
              $(
                '#' +
                  response.data[0].instrument_token +
                  '_' +
                  response.uniqId +
                  '_badla_buyP_bg',
              )
                .removeClass('credit-color-bg')
                .addClass('debit-color-bg');
            }
            if (
              Number(response.data[0]['buy_price_0']) == Number(preAmntBuyMcx)
            ) {
              $(
                '#' +
                  response.data[0].instrument_token +
                  '_' +
                  response.uniqId +
                  '_badla_buyP_bg',
              ).removeClass('credit-color-bg');
              $(
                '#' +
                  response.data[0].instrument_token +
                  '_' +
                  response.uniqId +
                  '_badla_buyP_bg',
              ).removeClass('debit-color-bg');
            }
            $(
              '#' +
                response.data[0].instrument_token +
                '_' +
                response.uniqId +
                '_prev_buy_comex',
            ).val(response.data[0]['buy_price_0']);

            //mcx previous sell
            let preAmntSellMcx = $(
              '#' +
                response.data[0].instrument_token +
                '_' +
                response.uniqId +
                '_prev_sell_comex',
            ).val();
            if (
              Number(response.data[0]['sell_price_0']) >= Number(preAmntSellMcx)
            ) {
              $(
                '#' +
                  response.data[0].instrument_token +
                  '_' +
                  response.uniqId +
                  '_badla_sellP_bg',
              )
                .removeClass('debit-color-bg')
                .addClass('credit-color-bg');
            }
            if (
              Number(response.data[0]['sell_price_0']) < Number(preAmntSellMcx)
            ) {
              $(
                '#' +
                  response.data[0].instrument_token +
                  '_' +
                  response.uniqId +
                  '_badla_sellP_bg',
              )
                .removeClass('credit-color-bg')
                .addClass('debit-color-bg');
            }
            if (
              Number(response.data[0]['sell_price_0']) == Number(preAmntSellMcx)
            ) {
              $(
                '#' +
                  response.data[0].instrument_token +
                  '_' +
                  response.uniqId +
                  '_badla_sellP_bg',
              ).removeClass('credit-color-bg');
              $(
                '#' +
                  response.data[0].instrument_token +
                  '_' +
                  response.uniqId +
                  '_badla_sellP_bg',
              ).removeClass('debit-color-bg');
            }
            $(
              '#' +
                response.data[0].instrument_token +
                '_' +
                response.uniqId +
                '_prev_sell_comex',
            ).val(response.data[0]['sell_price_0']);

            //Comex previous buy
            $(
              '#' +
                response.data[1].instrument_token +
                '_' +
                response.uniqId +
                '_comex_high',
            ).html(response.data[1]['ohlc_high']);
            $(
              '#' +
                response.data[1].instrument_token +
                '_' +
                response.uniqId +
                '_comex_low',
            ).html(response.data[1]['ohlc_low']);

            let preAmntBuyComex = $(
              '#' +
                response.data[1].instrument_token +
                '_' +
                response.uniqId +
                '_prev_buy_mcx',
            ).val();
            if (
              Number(response.data[1]['buy_price_0']) >= Number(preAmntBuyComex)
            ) {
              $(
                '#' +
                  response.data[1].instrument_token +
                  '_' +
                  response.uniqId +
                  '_badla_buyP_bg',
              )
                .removeClass('debit-color-bg')
                .addClass('credit-color-bg');
            }
            if (
              Number(response.data[1]['buy_price_0']) < Number(preAmntBuyComex)
            ) {
              $(
                '#' +
                  response.data[1].instrument_token +
                  '_' +
                  response.uniqId +
                  '_badla_buyP_bg',
              )
                .removeClass('credit-color-bg')
                .addClass('debit-color-bg');
            }
            if (
              Number(response.data[1]['buy_price_0']) == Number(preAmntBuyComex)
            ) {
              $(
                '#' +
                  response.data[1].instrument_token +
                  '_' +
                  response.uniqId +
                  '_badla_buyP_bg',
              ).removeClass('credit-color-bg');
              $(
                '#' +
                  response.data[1].instrument_token +
                  '_' +
                  response.uniqId +
                  '_badla_buyP_bg',
              ).removeClass('debit-color-bg');
            }
            $(
              '#' +
                response.data[1].instrument_token +
                '_' +
                response.uniqId +
                '_prev_buy_mcx',
            ).val(response.data[1]['buy_price_0']);

            //Comex previous sell
            let preAmntSellComex = $(
              '#' +
                response.data[1].instrument_token +
                '_' +
                response.uniqId +
                '_prev_sell_mcx',
            ).val();
            if (
              Number(response.data[1]['sell_price_0']) >=
              Number(preAmntSellComex)
            ) {
              $(
                '#' +
                  response.data[1].instrument_token +
                  '_' +
                  response.uniqId +
                  '_badla_sellP_bg',
              )
                .removeClass('debit-color-bg')
                .addClass('credit-color-bg');
            }
            if (
              Number(response.data[1]['sell_price_0']) <
              Number(preAmntSellComex)
            ) {
              $(
                '#' +
                  response.data[1].instrument_token +
                  '_' +
                  response.uniqId +
                  '_badla_sellP_bg',
              )
                .removeClass('credit-color-bg')
                .addClass('debit-color-bg');
            }
            if (
              Number(response.data[1]['sell_price_0']) ==
              Number(preAmntSellComex)
            ) {
              $(
                '#' +
                  response.data[1].instrument_token +
                  '_' +
                  response.uniqId +
                  '_badla_sellP_bg',
              ).removeClass('credit-color-bg');
              $(
                '#' +
                  response.data[1].instrument_token +
                  '_' +
                  response.uniqId +
                  '_badla_sellP_bg',
              ).removeClass('debit-color-bg');
            }
            $(
              '#' +
                response.data[1].instrument_token +
                '_' +
                response.uniqId +
                '_prev_sell_mcx',
            ).val(response.data[1]['sell_price_0']);

            //dgcx previous buy
            let preAmntBuyDgcx = $(
              '#' +
                response.data[2].instrument_token +
                '_' +
                response.uniqId +
                '_prev_buy_dgcx',
            ).val();
            if (
              Number(response.data[2]['buy_price_0']) >= Number(preAmntBuyDgcx)
            ) {
              $(
                '#' +
                  response.data[2].instrument_token +
                  '_' +
                  response.uniqId +
                  '_badla_buyP_bg',
              )
                .removeClass('debit-color-bg')
                .addClass('credit-color-bg');
            }
            if (
              Number(response.data[2]['buy_price_0']) < Number(preAmntBuyDgcx)
            ) {
              $(
                '#' +
                  response.data[2].instrument_token +
                  '_' +
                  response.uniqId +
                  '_badla_buyP_bg',
              )
                .removeClass('credit-color-bg')
                .addClass('debit-color-bg');
            }
            if (
              Number(response.data[2]['buy_price_0']) == Number(preAmntBuyDgcx)
            ) {
              $(
                '#' +
                  response.data[2].instrument_token +
                  '_' +
                  response.uniqId +
                  '_badla_buyP_bg',
              ).removeClass('credit-color-bg');
              $(
                '#' +
                  response.data[2].instrument_token +
                  '_' +
                  response.uniqId +
                  '_badla_buyP_bg',
              ).removeClass('debit-color-bg');
            }
            $(
              '#' +
                response.data[2].instrument_token +
                '_' +
                response.uniqId +
                '_prev_buy_dgcx',
            ).val(response.data[2]['buy_price_0']);

            //dgcx previous sell
            let preAmntSellDgcx = $(
              '#' +
                response.data[2].instrument_token +
                '_' +
                response.uniqId +
                '_prev_sell_dgcx',
            ).val();
            if (
              Number(response.data[2]['sell_price_0']) >=
              Number(preAmntSellDgcx)
            ) {
              $(
                '#' +
                  response.data[2].instrument_token +
                  '_' +
                  response.uniqId +
                  '_badla_sellP_bg',
              )
                .removeClass('debit-color-bg')
                .addClass('credit-color-bg');
            }
            if (
              Number(response.data[2]['sell_price_0']) < Number(preAmntSellDgcx)
            ) {
              $(
                '#' +
                  response.data[2].instrument_token +
                  '_' +
                  response.uniqId +
                  '_badla_sellP_bg',
              )
                .removeClass('credit-color-bg')
                .addClass('debit-color-bg');
            }
            if (
              Number(response.data[2]['sell_price_0']) ==
              Number(preAmntSellDgcx)
            ) {
              $(
                '#' +
                  response.data[2].instrument_token +
                  '_' +
                  response.uniqId +
                  '_badla_sellP_bg',
              ).removeClass('credit-color-bg');
              $(
                '#' +
                  response.data[2].instrument_token +
                  '_' +
                  response.uniqId +
                  '_badla_sellP_bg',
              ).removeClass('debit-color-bg');
            }
            $(
              '#' +
                response.data[2].instrument_token +
                '_' +
                response.uniqId +
                '_prev_sell_dgcx',
            ).val(response.data[2]['sell_price_0']);

            $(
              '#' +
                response.data[0].instrument_token +
                '_' +
                response.uniqId +
                '_badla_buyP',
            ).html(response.data[0]['buy_price_0']);
            $(
              '#' +
                response.data[0].instrument_token +
                '_' +
                response.uniqId +
                '_badla_sellP',
            ).html(response.data[0]['sell_price_0']);
            $(
              '#' +
                response.data[1].instrument_token +
                '_' +
                response.uniqId +
                '_badla_buyP',
            ).html(response.data[1]['buy_price_0']);
            $(
              '#' +
                response.data[1].instrument_token +
                '_' +
                response.uniqId +
                '_badla_sellP',
            ).html(response.data[1]['sell_price_0']);
            $(
              '#' +
                response.data[2].instrument_token +
                '_' +
                response.uniqId +
                '_badla_buyP',
            ).html(response.data[2]['buy_price_0']);
            $(
              '#' +
                response.data[2].instrument_token +
                '_' +
                response.uniqId +
                '_badla_sellP',
            ).html(response.data[2]['sell_price_0']);

            response.data[2]['last_price'] =
              10000 / response.data[2]['last_price'];
            let equation = response.equation;
            let duty = response['duty'][0]['Duty']
              ? Number(response['duty'][0]['Duty'])
              : 1;
            equation = equation.replace('L1', "response.data[1]['last_price']");
            equation = equation.replace('L1', "response.data[1]['last_price']");
            equation = equation.replace(
              /L3/g,
              "response.data[2]['last_price']",
            );
            equation = equation.replace(
              /L2/g,
              "response.data[0]['last_price']",
            );
            equation = equation.replace(/D1/g, 'duty');
            let equ = eval(equation);
            let equNext;
            if (response.data[3]) {
              response.data[3]['last_price'] =
                10000 / response.data[3]['last_price'];
              let equationNext = response.equation;
              equationNext = equationNext.replace(
                'L1',
                "response.data[1]['last_price']",
              );
              equationNext = equationNext.replace(
                'L1',
                "response.data[1]['last_price']",
              );
              equationNext = equationNext.replace(
                /L3/g,
                "response.data[3]['last_price']",
              );
              equationNext = equationNext.replace(
                /L2/g,
                "response.data[0]['last_price']",
              );
              equationNext = equationNext.replace(/D1/g, 'duty');
              equNext = eval(equationNext);
              let finalBadlaNext =
                reverse && reverse == '1'
                  ? equNext - response.data[0].last_price
                  : response.data[0].last_price - equNext;
              $('#' + response.uniqId + '_next').html(
                finalBadlaNext.toFixed(2),
              );
            }

            //let equ = Math.round(((((response.data[1].last_price+1)*31.99)*(response.data[2].last_price+0.01))/100)+(((((response.data[1].last_price+1)*31.99)*(response.data[2].last_price+0.01))*15)/10000))
            //let finalBadla = response.data[0].last_price - equ;
            let finalBadla =
              reverse && reverse == '1'
                ? equ - response.data[0].last_price
                : response.data[0].last_price - equ;

            $('#' + response.uniqId).html(finalBadla.toFixed(2));

            if (Number(finalBadla) > 0) {
              $('#' + response.uniqId)
                .removeClass('debit-color')
                .addClass('credit-color');
            } else {
              $('#' + response.uniqId)
                .removeClass('credit-color')
                .addClass('debit-color');
            }

            //buy price badla
            response.data[2]['buy_price_0'] =
              10000 / response.data[2]['buy_price_0'];
            let equationBuy = response.equation;
            equationBuy = equationBuy.replace(
              'L1',
              "response.data[1]['sell_price_0']",
            );
            equationBuy = equationBuy.replace(
              'L1',
              "response.data[1]['sell_price_0']",
            );
            equationBuy = equationBuy.replace(
              /L3/g,
              "response.data[2]['buy_price_0']",
            );
            equationBuy = equationBuy.replace(
              /L2/g,
              "response.data[0]['buy_price_0']",
            );
            // this.badlaInstruments.forEach((instrument) => {
            //   if (instrument.settingValue && instrument.settingValue.length > 0) {
            //     equationBuy = equationBuy.replace(/D1/g, instrument.settingValue[0].Duty);
            //   }
            // });
            equationBuy = equationBuy.replace(/D1/g, 'duty');

            let equBuy = eval(equationBuy);

            $(
              '#' +
                response.data[0].instrument_token +
                '_' +
                response.uniqId +
                '_badla_dollerBuy',
            ).html(equBuy.toFixed(2));
            $(
              '#' +
                response.data[2].instrument_token +
                '_' +
                response.uniqId +
                '_badla_dollerPBuy',
            ).html(response.data[2]['buy_price_0'].toFixed(2));

            //let finalBadlaBuy = response.data[0].buy_price_0 - equBuy;
            let finalBadlaBuy =
              reverse && reverse == '1'
                ? equBuy - response.data[0].buy_price_0
                : response.data[0].buy_price_0 - equBuy;

            $('#sell_' + response.uniqId).html(finalBadlaBuy.toFixed(2));
            if (Number(finalBadlaBuy) > 0) {
              $('#sell_' + response.uniqId)
                .removeClass('debit-color')
                .addClass('credit-color');
            } else {
              $('#sell_' + response.uniqId)
                .removeClass('credit-color')
                .addClass('debit-color');
            }

            //sell price badla
            response.data[2]['sell_price_0'] =
              10000 / response.data[2]['sell_price_0'];
            let equationSell = response.equation;
            equationSell = equationSell.replace(
              'L1',
              "response.data[1]['buy_price_0']",
            );
            equationSell = equationSell.replace(
              'L1',
              "response.data[1]['buy_price_0']",
            );
            equationSell = equationSell.replace(
              /L3/g,
              "response.data[2]['sell_price_0']",
            );
            equationSell = equationSell.replace(
              /L2/g,
              "response.data[0]['sell_price_0']",
            );
            // if (this?.badlaInstruments?.length > 0) {
            // this.badlaInstruments.forEach((instrument) => {
            //   if (instrument.settingValue && instrument.settingValue.length > 0) {
            //     equationSell = equationSell.replace(/D1/g, instrument.settingValue[0].Duty);
            //   }
            // });
            equationSell = equationSell.replace(/D1/g, 'duty');

            let equSell = eval(equationSell);
            $(
              '#' +
                response.data[0].instrument_token +
                '_' +
                response.uniqId +
                '_badla_dollerSell',
            ).html(equSell.toFixed(2));
            $(
              '#' +
                response.data[2].instrument_token +
                '_' +
                response.uniqId +
                '_badla_dollerPSell',
            ).html(response.data[2]['sell_price_0'].toFixed(2));

            let finalBadlaSell =
              reverse && reverse == '1'
                ? equSell - response.data[0].sell_price_0
                : response.data[0].sell_price_0 - equSell;
            $('#buy_' + response.uniqId).html(finalBadlaSell.toFixed(2));
            if (Number(finalBadlaSell) > 0) {
              $('#buy_' + response.uniqId)
                .removeClass('debit-color')
                .addClass('credit-color');
            } else {
              $('#buy_' + response.uniqId)
                .removeClass('credit-color')
                .addClass('debit-color');
            }

            // let preAmntBadla = $("#" + response.uniqId + "_prev_finalBadla").val();
            // if(Number(finalBadla) > Number(preAmntBadla)){
            //   $("#" + response.uniqId).removeClass('debit-color').addClass('credit-color');
            // }
            // if(Number(finalBadla) < Number(preAmntBadla)){
            //   $("#" + response.uniqId).removeClass('credit-color').addClass('debit-color');
            // }
            // $("#" + response.uniqId + "_prev_finalBadla").val(finalBadla);

            // console.log('equ++++++++++',equ);
          } else {
            response.data.map((result, index) => {
              $('#' + result.instrument_token + '_buyprice').html(
                result.buy_price_0,
              );
              $('#' + result.instrument_token + '_sellprice').html(
                result.sell_price_0,
              );
              $('#' + result.instrument_token + '_net_change').html(
                result.net_change,
              );
              $('#' + result.instrument_token + '_high').html(result.ohlc.high);
              $('#' + result.instrument_token + '_low').html(result.ohlc.low);
            });
          }
        }
      });
  }

  getRandomString(length) {
    var result = '';
    var characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  showToster(title, type, message) {
    this.Toast.title = title;
    this.Toast.type = type;
    this.Toast.body = message;
    this.commonService.popToast(type, title, 1500, message);
  }

  openBadlaInfo(binstu) {
    this.diffrenceRate =
      binstu['diffrenceValue'] !== null ? binstu['diffrenceValue'] : 0;
    this.badlaInfo = binstu;
    // stores the initial value of Duty
    this.initialDutyValue = this.badlaInfo.settingValue[0]['Duty'];
    this.badlaInfoModal.show();
  }

  openbadlaAddModal(binstu) {
    this.orderModal.show();
    this.selectedBadlaTypeFrm = binstu['badlaType'];
    // this.filter.badlaType = "ALL"
    this.filter.type = binstu._id;
    this.filter.duty = binstu.settingValue[0]['Duty'];
    let findComex = binstu.instrumentsDetail.find(
      (inst) => inst['exchange'] == 'COMEX',
    );
    if (findComex) {
      this.filter['comexbadlaInst'] = findComex['instrument_token'];
      this.chnageInsrument(findComex['instrument_token'], 'comexRateId');
    }
    let findMCX = binstu.instrumentsDetail.find(
      (inst) => inst['exchange'] == 'MCX',
    );
    if (findMCX) {
      this.filter['mcxbadlaInst'] = findMCX['instrument_token'];
      this.chnageInsrument(findMCX['instrument_token'], 'mcxRateId');
    }
    let findDGCX = binstu.instrumentsDetail.find(
      (inst) => inst['exchange'] == 'DGCX',
    );
    if (findDGCX) {
      this.filter['dgcxbadlaInst'] = findDGCX['instrument_token'];
      this.chnageInsrument(findDGCX['instrument_token'], 'dgcxRateId');
    }
  }

  closeBadlaOrder() {
    //Duty value back to its original state
    this.badlaInfo.settingValue[0]['Duty'] = this.initialDutyValue;
    this.badlaInfoModal.hide();
  }
  closeModal() {
    this.clearRate();
    this.isBrokrageCheck = null;
    this.addBadlaOrder.resetForm();
    this.orderModal.hide();
  }

  clearRate() {
    $('#dgcxRateId').html('');
    $('#mcxRateId').html('');
    $('#comexRateId').html('');
    this.closingRate = null;
    this.dollerClCheck = false;
    this.settlementType = '';
    this.filter.type = null;
  }

  checkBrokrageEnd(check) {
    this.isBrokrageCheck = check;
  }

  checkBrokrage(check) {
    this.isBrokrageCheck = check;
  }

  checkEndClosing(check) {
    this.isEndClosingRate = check;
  }

  checkBrokrageRO(check) {
    this.isBrokrageROCheck = check;
  }

  clearingRate(check) {
    this.dollerClCheck = check;
  }

  settlementTypeChnage(id) {
    this.backendApiService.getDoller(1).subscribe((dollerRate) => {
      if (dollerRate['status'] == 1) {
        this.closingRate = dollerRate['data']['dollerRate'];
      }
    });
    this.settlementType = id;
  }

  comexTypeChnage() {
    if (this.filter.comexType == 'buy') {
      this.filter.mcxType = 'sell';
      this.filter.dgcxType = 'sell';
    } else if (this.filter.comexType == 'sell') {
      this.filter.mcxType = 'buy';
      this.filter.dgcxType = 'buy';
    } else {
      this.filter.mcxType = '';
      this.filter.dgcxType = '';
    }
  }

  chnageInsrument(instrumentToken, id) {
    if (instrumentToken[0] != 0) {
      let totalInstrument = [instrumentToken + '_full'];
      this.backendApiService
        .getLastPrice(totalInstrument)
        .subscribe((badlaLatestRate) => {
          if (
            badlaLatestRate['status'] == true &&
            badlaLatestRate['data'].length > 0
          ) {
            let badlaRateRes = _.map(
              badlaLatestRate['data'],
              function (resIns) {
                return JSON.parse(resIns);
              },
            );

            let price =
              badlaRateRes[0]['buy_price_0'] +
              ' | ' +
              badlaRateRes[0]['sell_price_0'];
            $('#' + id).html(price);
            $('#' + id + 'Rollover').html(price);
          }
        });
    } else {
      $('#' + id).html('');
    }
  }

  badlaScriptChnage(id) {
    // console.log('id+++++++',id);
    let badlaDuty = _.find(this.badlaInstrument, function (o) {
      return o._id == id;
    });
    if (badlaDuty) {
      this.filter['duty'] = badlaDuty['settingValue'][0]['Duty'];
      let badlaType = badlaDuty['badlaType'] ? badlaDuty['badlaType'] : null;
      if (badlaType) {
        let filterComex = [];
        // console.log('badlaType++++++',badlaType);
        // console.log(this['allComexInstrument']);
        _.map(this['allComexInstrument'], function (resIns) {
          let position = -1;
          if (badlaType == 'GOLD') {
            position = resIns['name'].search(/gold/i);
          }
          if (badlaType == 'SILVER') {
            position = resIns['name'].search(/silver/i);
          }
          if (badlaType == 'COPPER') {
            position = resIns['name'].search(/copper/i);
          }
          if (badlaType == 'CRUDE') {
            // console.log(resIns['name']);
            position = resIns['name'].search(/crude/i);
          }
          if (badlaType == 'GAS') {
            position = resIns['name'].search(/GAS/);
          }

          if (position != -1) {
            filterComex.push(resIns);
          }
        });
        this['comexBadlaInstrument'] = filterComex;

        let filterMcx = [];
        _.map(this['allMcxInstrument'], function (resIns) {
          let position = -1;
          if (badlaType == 'GOLD') {
            position = resIns['name'].search(/gold/i);
          }
          if (badlaType == 'SILVER') {
            position = resIns['name'].search(/silver/i);
          }
          if (badlaType == 'COPPER') {
            position = resIns['name'].search(/copper/i);
          }
          if (badlaType == 'CRUDE') {
            position = resIns['name'].search(/crude/i);
          }
          if (badlaType == 'GAS') {
            position = resIns['name'].search(/GAS/);
          }

          if (position != -1) {
            filterMcx.push(resIns);
          }
        });
        this['mcxBadlaInstrument'] = filterMcx;
      } else {
        this['comexBadlaInstrument'] = this['allComexInstrument'];
        this['mcxBadlaInstrument'] = this['allMcxInstrument'];
        this['dhcxBadlaInstrument'] = this['allDgcxInstrument'];
      }
    }
  }

  createBadlaOrder() {
    //this.spinnerService.show();
    let type = this.filter['type'];
    let findDiffrence = _.find(this.badlaInstrument, function (o) {
      return o._id == type;
    });
    let reverse = '0';
    if (findDiffrence) {
      reverse = findDiffrence['reverse'] ? findDiffrence['reverse'] : '0';
    }
    let filterInstu = this.filter;
    let mcxbadlaInst = this.filter.mcxbadlaInst;
    let comexbadlaInst = this.filter.comexbadlaInst;
    let dgcxbadlaInst = this.filter.dgcxbadlaInst;
    let badlaId = this.filter.type;
    let mcxDetail = _.find(this.badlaRecordDetails, function (o) {
      return o.instrument_token == mcxbadlaInst;
    });
    let comexDetail = _.find(this.badlaRecordDetails, function (o) {
      return o.instrument_token == comexbadlaInst;
    });
    let dgcxDetail = _.find(this.badlaRecordDetails, function (o) {
      return o.instrument_token == dgcxbadlaInst;
    });
    let findBadlaEquestion = _.find(this.badlaInstrument, function (o) {
      return o._id == badlaId;
    });
    let duty = Number(this.filter['duty']);

    this.filter['mcxDetail'] = mcxDetail ? mcxDetail : [];
    this.filter['comexDetail'] = comexDetail ? comexDetail : [];
    this.filter['dgcxDetail'] = dgcxDetail ? dgcxDetail : [];
    this.filter['checkBrokrage'] = this.isBrokrageCheck;
    let findBadla = findBadlaEquestion['equation'];
    this.filter['settingName'] = findBadlaEquestion['settingName'];
    let totalInstrument = [
      this.filter.mcxbadlaInst,
      this.filter.comexbadlaInst,
      this.filter.dgcxbadlaInst,
    ];
    totalInstrument = _.map(totalInstrument, function (resIns) {
      return resIns + '_full';
    });

    this.backendApiService
      .getLastPrice(totalInstrument)
      .subscribe((badlaLatestRate) => {
        let finalBadla = 0;
        let currentBadla = 0;
        let weeklyBadla = 0;
        if (badlaLatestRate.status == true) {
          let badlaRateRes = [];
          badlaRateRes = _.map(badlaLatestRate.data, function (resIns) {
            return JSON.parse(resIns);
          });
          let mcxLiveRate = _.find(badlaRateRes, function (o) {
            return o.instrument_token == mcxbadlaInst;
          });
          let comexLiveRate = _.find(badlaRateRes, function (o) {
            return o.instrument_token == comexbadlaInst;
          });
          let dgcxLiveRate = _.find(badlaRateRes, function (o) {
            return o.instrument_token == dgcxbadlaInst;
          });

          //taking a variable for price condition
          let dgcxPriceCon =
            this.filter['dgcxType'] == 'buy'
              ? dgcxLiveRate['buy_price_0']
              : dgcxLiveRate['sell_price_0'];
          let comexPriceCon =
            this.filter['comexType'] == 'buy'
              ? comexLiveRate['buy_price_0']
              : comexLiveRate['sell_price_0'];
          let mcxPriceCon =
            this.filter['mcxType'] == 'buy'
              ? mcxLiveRate['buy_price_0']
              : mcxLiveRate['sell_price_0'];
          dgcxPriceCon = 10000 / dgcxPriceCon;
          dgcxPriceCon =
            this.filter.endandopen == '3'
              ? Number(this.closingRate)
              : this.filter.endandopen == '1' && this.isEndClosingRate == true
                ? Number(this.closingRate)
                : dgcxPriceCon;
          let equation = findBadla;
          equation = equation.replace('L1', 'comexPriceCon');
          equation = equation.replace('L1', 'comexPriceCon');
          equation = equation.replace(/L3/g, 'dgcxPriceCon');
          equation = equation.replace(/D1/g, 'duty');

          let equ = eval(equation);
          finalBadla =
            reverse && reverse == '1' ? equ - mcxPriceCon : mcxPriceCon - equ;
          filterInstu['comexPrice'] = Number(filterInstu['comexPrice']);
          filterInstu['dgcxPrice'] = Number(filterInstu['dgcxPrice']);
          let divedDgcx = 10000 / filterInstu['dgcxPrice'];
          divedDgcx =
            this.filter.endandopen == '3'
              ? Number(this.closingRate)
              : this.filter.endandopen == '1' && this.isEndClosingRate == true
                ? Number(this.closingRate)
                : divedDgcx;
          let currentRateEqu = findBadla;
          currentRateEqu = currentRateEqu.replace(
            'L1',
            "filterInstu['comexPrice']",
          );
          currentRateEqu = currentRateEqu.replace(
            'L1',
            "filterInstu['comexPrice']",
          );
          currentRateEqu = currentRateEqu.replace(/L3/g, 'divedDgcx');
          currentRateEqu = currentRateEqu.replace(/D1/g, 'duty');
          let curEqu = eval(currentRateEqu);
          // currentBadla = Number(filterInstu['mcxPrice']) - curEqu;
          currentBadla =
            reverse && reverse == '1'
              ? curEqu - Number(filterInstu['mcxPrice'])
              : Number(filterInstu['mcxPrice']) - curEqu;

          filterInstu['equation'] = findBadla;
          // this.filter['dollerClearingRate'] = dgcxPriceCon;
          let dollerClrRate =
            this.filter.endandopen == '3'
              ? Number(this.closingRate)
              : this.filter.endandopen == '1' && this.isEndClosingRate == true
                ? Number(this.closingRate)
                : 10000 / Number(this.filter['dgcxPrice']);
          this.filter['dollerClearingRate'] = dollerClrRate;

          //weekly settled badla fixed price
          let weeklyDgcx = 10000 / filterInstu['dgcxPrice'];
          let weeklySettleBadla = findBadla;
          weeklySettleBadla = weeklySettleBadla.replace(
            'L1',
            "filterInstu['comexPrice']",
          );
          weeklySettleBadla = weeklySettleBadla.replace(
            'L1',
            "filterInstu['comexPrice']",
          );
          weeklySettleBadla = weeklySettleBadla.replace(/L3/g, 'weeklyDgcx');
          weeklySettleBadla = weeklySettleBadla.replace(/D1/g, 'duty');
          let weeklyEqu = eval(weeklySettleBadla);
          weeklyBadla =
            reverse && reverse == '1'
              ? weeklyEqu - Number(filterInstu['mcxPrice'])
              : Number(filterInstu['mcxPrice']) - weeklyEqu;
        }
        setTimeout(() => {
          let comexD = {
            instrument_token: comexDetail['instrument_token'],
            original_exchange: comexDetail['original_exchange'],
            name: comexDetail['name'],
            tradingsymbol: comexDetail['tradingsymbol'],
            expiry: comexDetail['expiry'],
          };
          let mcxD = {
            instrument_token: mcxDetail['instrument_token'],
            original_exchange: mcxDetail['original_exchange'],
            name: mcxDetail['name'],
            tradingsymbol: mcxDetail['tradingsymbol'],
            expiry: mcxDetail['expiry'],
          };
          let dgcxD = {
            instrument_token: dgcxDetail['instrument_token'],
            original_exchange: dgcxDetail['original_exchange'],
            name: dgcxDetail['name'],
            tradingsymbol: dgcxDetail['tradingsymbol'],
            expiry: dgcxDetail['expiry'],
          };
          this.filter['instrumentAry'] = [comexD, mcxD, dgcxD];
          this.filter['currentBadla'] = finalBadla.toFixed(2);
          this.filter['rateBadla'] = currentBadla.toFixed(2);
          this.filter['userId'] = this.userId;
          this.filter['isOpen'] = true;
          this.filter['badlRefId'] = this.getRandomString(6);
          // this.filter['weeklySettleBadla'] = currentBadla.toFixed(0);
          this.filter['openingAmount'] = this.filter['openingAmount']
            ? this.filter['openingAmount']
            : '0';
          this.filter.reverse = reverse;
          this.backendApiService
            .saveBadlaOrder(this.filter)
            .subscribe((response) => {
              if (response.status == true) {
                this.spinnerService.hide();
                this.closeModal();
                this.showToster('Success', 'success', 'Order Placed...');
                this.router.navigate(['/badlaorder']);
              } else {
                this.closeModal();
                this.showToster('Error', 'error', 'Something went wrong.');
              }
            });
        }, 300);
      });

    return false;
  }

  badlaTypeChnage(type) {
    this.allScript = [];
    if (type == 'ALL') {
      this.allScript = this.withoutFilterScript;
    } else {
      let filterCategoryWise = _.filter(this.withoutFilterScript, function (o) {
        if (o['badlaType'] == type) {
          return o;
        }
      });
      this.allScript = filterCategoryWise;
    }
  }
}
